// extracted by mini-css-extract-plugin
export var displayNone = "_u9-6";
export var imgContainer = "_u9-2";
export var overflowHidden = "_u9-3";
export var productInfoCardButtonContainer = "_u9-5";
export var productTitleText = "_u9-4";
export var rightArrow = "_u9-1";
export var rightArrowContainer = "_u9-0";